interface Quantities {
  quantity: number;
  verificationQuantity: number;
}

// Паспорт с 09.09.2026 входит в поверку и отдельной позицией к датчику не
// продаётся (вынесен в собственную карточку каталога), поэтому связки
// «поверка ⇒ паспорт» больше нет. Остаётся одно правило: поверок не может
// быть больше, чем самих датчиков.

export function adjustOnQuantityChange(
  newQuantity: number,
  verificationQuantity: number
): Quantities {
  return {
    quantity: newQuantity,
    verificationQuantity: Math.min(verificationQuantity, newQuantity),
  };
}

export function adjustOnVerificationChange(
  quantity: number,
  newVerification: number
): Quantities {
  return {
    // Просят поверок больше, чем датчиков в строке — подтягиваем количество,
    // а не режем ввод: так вело себя и старое правило.
    quantity: Math.max(quantity, newVerification),
    verificationQuantity: newVerification,
  };
}
